import { breakpoints, classes } from '@theme/helpers';
import { HTMLShopifySectionElement } from '@theme/html-custom-element';

const DESKTOP_HOVER = `(min-width: ${breakpoints.large}px) and (hover: hover)`;

class ShopTheLook extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (!this.refs.hotspot) return;

    this.desktopHoverMql = window.matchMedia(DESKTOP_HOVER);

    this.on('click', this.refs.hotspot.all, (event) => {
      if (this.desktopHoverMql.matches) return;

      this.activate(event.currentTarget.dataset.block);
    });

    const firstHotspot = this.refs.hotspot.all[0];

    this.defaultBlockId = firstHotspot?.dataset.block;

    if (this.defaultBlockId) {
      this.activate(this.defaultBlockId);
    }

    this.on('mouseenter', this.refs.hotspot.all, (event) => {
      if (!this.desktopHoverMql.matches) return;

      this.activate(event.currentTarget.dataset.block);
    });

    if (this.refs.card) {
      this.on('mouseenter', this.refs.card.all, (event) => {
        if (!this.desktopHoverMql.matches) return;

        this.activate(event.currentTarget.dataset.block);
      });
    }

    if (this.refs.image) {
      this.on('mouseleave', this.refs.image, () => {
        if (!this.desktopHoverMql.matches || !this.defaultBlockId) return;

        this.activate(this.defaultBlockId);
      });
    }
  }

  /**
   * @param {string} blockId
   */
  activate(blockId) {
    for (const hotspot of this.refs.hotspot.all) {
      const isActive = hotspot.dataset.block === blockId;

      hotspot.classList.toggle(classes.active, isActive);
      hotspot.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    }

    if (this.refs.card) {
      for (const card of this.refs.card.all) {
        card.classList.toggle(classes.active, card.dataset.block === blockId);
      }
    }
  }

  /**
   * @param {object} event
   */
  onBlockSelect(event) {
    this.activate(event.detail.blockId);
  }
}

if (!customElements.get('shop-the-look')) customElements.define('shop-the-look', ShopTheLook);
